import { useEffect } from "react";
import { useQuery } from "react-query";
import { api } from "services/api";
import { AttendanceContent } from "types/AttendanceContent";
import { handleRequestError } from "utils/Request";

type AttendanceContentsParams = {
  category: string
}

export async function fetchAttendanceContents(params?: AttendanceContentsParams): Promise<AttendanceContent[]> {
  const { data } = await api.get(`/tecimob/subjects/${params?.category}`);
  return data;
}

export function useAttendanceContents(params?: AttendanceContentsParams) {
  const query = useQuery(
    ['attendanceContents', params],
    () => fetchAttendanceContents(params),
    { enabled: !!params }
  );

  useEffect(() => {
    if (!query.isError) return;
    handleRequestError(query.error, 'Ocorreu um erro ao listar os conteúdos de atendimento. Por favor, tente novamente!');
  }, [query.isError, query.error]);

  return query;
}

